function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("desc", null, "Flag of Germany");

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  id: "black_stripe",
  width: 5,
  height: 3,
  y: 0,
  x: 0,
  fill: "#000"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  id: "red_stripe",
  width: 5,
  height: 2,
  y: 1,
  x: 0,
  fill: "#D00"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  id: "gold_stripe",
  width: 5,
  height: 1,
  y: 2,
  x: 0,
  fill: "#FFCE00"
});

var SvgDe = function SvgDe(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 5 3"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/de.fb15113a.svg";
export { SvgDe as ReactComponent };